import { REQUEST_DATA, RECEIVE_DATA } from './../actions/DataAction';

let defaultState = {
    fetched   : false,
    isFetching: false,
    data      : null
};

const data = (state = defaultState, action) => {
    let newState;
    switch (action.type)
    {
        case REQUEST_DATA:
            newState = {
                ...state,
                fetched   : false,
                isFetching: true
            };
            break;
        case RECEIVE_DATA:
            newState = {
                ...state,
                fetched   : true,
                isFetching: true
            };
            break;
        default:
            newState = state;
            break;
    }

    return newState;
};

export default data;


// WEBPACK FOOTER //
// ./src/reducers/DataReducer.js